import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

const FIELDS = [
    ["children_supported", "Children Supported"],
    ["women_empowered", "Women Empowered"],
    ["villages_covered", "Villages Covered"],
    ["digital_literacy_students", "Digital Literacy Students"],
    ["community_programmes", "Community Programmes Conducted"],
    ["volunteers_engaged", "Volunteers Engaged"],
    ["partner_organisations", "Partner Organisations"],
    ["years_of_service", "Years of Service"],
];

export default function AdminImpact() {
    const [form, setForm] = useState(null);
    useEffect(() => {
        api.get("/impact-stats").then((r) => setForm(r.data || {}));
    }, []);

    const save = async () => {
        try {
            const payload = { ...form };
            for (const [k] of FIELDS) payload[k] = Number(payload[k]) || 0;
            await api.put("/impact-stats", payload);
            toast.success("Impact updated");
        } catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
    };

    if (!form) return <div className="text-slate-500">Loading…</div>;

    return (
        <div data-testid="admin-impact" className="max-w-3xl">
            <h1 className="text-2xl font-semibold mb-2">Impact counters</h1>
            <p className="text-sm text-slate-500 mb-6">These numbers appear on the homepage and Impact page.</p>
            <div className="bg-white border border-slate-200 rounded-lg p-6 space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {FIELDS.map(([k, l]) => (
                        <label key={k} className="block">
                            <div className="text-xs uppercase tracking-[0.15em] text-slate-500 font-semibold mb-1">{l}</div>
                            <input
                                type="number"
                                value={form[k] ?? 0}
                                onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                                data-testid={`impact-input-${k}`}
                                className="w-full px-3 py-2 rounded border border-slate-200 text-sm"
                            />
                        </label>
                    ))}
                </div>
                <div>
                    <div className="text-xs uppercase tracking-[0.15em] text-slate-500 font-semibold mb-1">Intro text</div>
                    <textarea rows="3" value={form.intro_text || ""} onChange={(e) => setForm({ ...form, intro_text: e.target.value })} className="w-full px-3 py-2 rounded border border-slate-200 text-sm resize-none" />
                </div>
            </div>
            <div className="mt-6 flex justify-end">
                <button onClick={save} data-testid="impact-save" className="px-5 py-2.5 rounded-md bg-brand-forest text-white text-sm font-semibold inline-flex items-center gap-2"><Save size={14} /> Save changes</button>
            </div>
        </div>
    );
}
